// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"d1f83b5f","428":"d3e3589e","444":"147452ed","548":"4b043039","597":"c52671fd","642":"7d7e27ff","649":"fb5792e4","737":"6d25747f","882":"6e309abb","901":"4fad359b"}[chunkId] + ".chunk.js";
};